<template>
  <pagelayout contentBgcolor="#fff">
    <div class="guadan-log-list d-flex flex-column">
      <!-- :title="type == 1 ? '挂单充值' : '挂单提现'" -->
      <Appbar title="挂单日志">
        <div slot="right" :style="`color: ${$vuetify.theme.themes.light.front}`" @click="loadAgin">刷新</div>
      </Appbar>

      <div v-if="pageLoading == 2" class="log-content flex-grow-1">
        <div class="log-box">
          <div class="tx-log" v-if="logList.length">
            <div class="time-line"></div>
            <div class="log-li" v-for="(e, i) in logList" :key="i">
              <div class="l-text have-line" :style="getColor(e.title)">
                {{ e.title }}
                <div class="l-circle"></div>
              </div>
              <div class="l-text img-box" v-if="Array.isArray(e.imgArr)">
                <img
                  class="img-li"
                  v-for="(el, i) in e.imgArr"
                  :key="i"
                  :src="el"
                  alt=""
                  @click="checkPreImg(false, i, [...e.imgArr])"
                />
              </div>
              <div class="l-text" v-if="Array.isArray(e.textObj)">
                <div>{{ e.textObj[0] }}</div>
                <div>{{ e.textObj[1] }}</div>
              </div>

              <div style="color:#bbb">{{ e.operTime }}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="pageLoading == 1" class="loading-holder">
        <v-progress-circular indeterminate :size="25" color="#666"></v-progress-circular>
      </div>
      <div v-if="pageLoading == 3" class="err-try-agin" @click="loadAgin">加载失败,点击重试</div>
    </div>
  </pagelayout>
</template>

<script>
import Appbar from '@c/layout/Appbar'
import { ApigetGuadanQueryQueryWgdOperLog, ApigetGuadanQueryRgdOperLog } from '@api/service'
export default {
  components: {
    Appbar
  },
  data() {
    return {
      type: 1,
      logList: [],
      pageLoading: 0 //0未加载 1加载中 2加载成功 3加载失败
    }
  },
  methods: {
    //提现日志
    async getLog({ orderNo, type, rgdNo, wgdNo }) {
      if (this.pageLoading == 1) return
      this.pageLoading = 1
      let res = {}
      if (type == 1) {
        res = await ApigetGuadanQueryRgdOperLog({ rgdNo, wgdNo })
      } else {
        res = await ApigetGuadanQueryQueryWgdOperLog({ wgdNo: orderNo })
      }

      if (res.code == '12200') {
        //过滤日志中的图片
        res.data.map(e => {
          if (e.operInfo.includes('https')) {
            e.title = '挂单充值-上传凭证'
            e.imgArr = e.operInfo.match(/https.*?\.(jpg|png|jpeg)/gi)
          } else if (e.operInfo.includes(',')) {
            let textArr = e.operInfo.split(',')
            let LastIndex = textArr.length - 1
            const sellOrPayText = e.operType == 1040 ? '卖家' : '买家'
            e.title = `挂单充值-反馈投诉(${sellOrPayText})`
            e.textObj = [[...textArr].splice(0, LastIndex).join(), textArr[LastIndex]]
          } else {
            e.title = e.operInfo
          }
        })
        res.data.sort((a, b) => {
          return b.logId - a.logId
        })
        this.logList = res.data
        this.pageLoading = 2
      } else {
        this.pageLoading = 3
      }
    },
    getColor(text) {
      if (text.includes('卖')) {
        return 'color: rgb(230, 162, 60);'
      } else {
        return 'color: rgb(64, 158, 255);'
      }
    },
    checkPreImg(isSavePic = false, index = 0, imgData = []) {
      this.$router.push({
        path: '/Recharge/PayOnlineGuadanPreImg',
        query: {
          isSavePic,
          imgData: JSON.stringify(imgData),
          index
        }
      })
    },
    async loadAgin() {
      const { orderNo, type, rgdNo, wgdNo } = this.$route.query
      this.type = type
      await this.getLog({ orderNo, type, rgdNo, wgdNo })
    }
  },
  async created() {
    const { orderNo, type, rgdNo, wgdNo } = this.$route.query
    this.type = type
    await this.getLog({ orderNo, type, rgdNo, wgdNo })
  }
}
</script>

<style lang="scss" scoped>
.guadan-log-list {
  height: 100%;
  overflow: auto;
  .err-try-agin {
    height: 48px;
    line-height: 48px;
    text-align: center;
    margin-top: 20px;
    font-size: 16px;
  }
  .loading-holder {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .log-content {
    .tx-log {
      background-color: #fff;
      padding-left: 30px;
      position: relative;

      &.mb70 {
        margin-bottom: 70px;
      }

      .time-line {
        position: absolute;
        height: 100%;
        width: 2px;
        background-color: #ccc;
        top: 0;
        left: 14px;
      }

      .log-li {
        margin-top: 10px;

        .l-text {
          overflow-wrap: break-word;

          &.have-line {
            position: relative;

            .l-circle {
              position: absolute;
              background-color: #ccc;
              height: 12px;
              width: 12px;
              border-radius: 50%;
              top: 50%;
              transform: translateY(-50%);
              left: -21px;
            }
          }

          &.img-box {
            display: flex;

            .img-li {
              width: 50px;
              height: 50px;
              margin-right: 10px;
            }
          }
        }
      }
    }
  }
}
</style>
